import React from "react";
import { FaLinkedin, FaTwitter } from "react-icons/fa";
import { teams } from "../../../data/CompanyData";
const OurTeam = () => {
  return (
    <div className="lg:px-10 py-5 md:px-10 px-5">
      <div className="flex justify-center text-center flex-col lg:w-1/2 mx-auto">
        <p className="text-sm text-primary font-semibold">Join us!</p>
        <h3 className="text-2xl font-bold text-black">Meet our team</h3>
        <p className="text-accent text-md">
          Our philosophy is simple — hire a team of diverse, passionate people
          and foster a culture that empowers you to do you best work.
        </p>
      </div>
      <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-8 my-5">
        {teams.map((team) => (
          <div key={team.id} className="space-y-3">
            <img src={team.img} alt="" className="w-full aspect-auto" />
            <div>
              <h3 className="text-black font-bold">{team.name}</h3>
              <p className="text-primary text-sm font-semibold">{team.title}</p>
            </div>
            <p className="text-accent text-[12px]">{team.text}</p>
            <div className="text-xl text-accent flex gap-2 items-center">
              <a
                target={"_blank"}
                href={team.twitter}
                className="hover:text-primary"
              >
                <FaTwitter />
              </a>
              <a
                target={"_blank"}
                href={team.linkedin}
                className="hover:text-primary"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
